<template>
  <div class="text-magazine-editions">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="title-section">Nova</div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for>
              Revista
              <span class="required-field">*</span>
            </label>
            <select v-model="text_magazine_edition.magazine_id" class="form-control">
              <option
                v-for="item in createParams.magazines"
                :value="item.id"
                v-bind:key="item.id"
              >{{item.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for>
              Nº da Edição
              <span class="required-field">*</span>
            </label>
            <input
              v-model="text_magazine_edition.edition_number"
              type="number"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for>
              Nº da Página
              <span class="required-field">*</span>
            </label>
            <input v-model="text_magazine_edition.page_number" type="number" class="form-control" />
          </div>
        </div>
        <div class="col-lg-2" style="padding-top:30px">
          <button class="btn btn-primary float-right" v-on:click="save()">Adicionar</button>
        </div>
      </div>
      <div class="row table-row">
        <div class="col-12">
          <b-table :fields="fields" :items="data" :per-page="0" :current-page="currentPage">
            <template
              v-slot:cell(magazine_edition)="data"
            >{{`${getMonthLabel(data.value.month)} ${data.value.year} - nº ${data.value.edition_number}`}}</template>
            <template v-slot:cell(id)="data">
              <i
                class="fa fa-trash-o deleteIcon"
                aria-hidden="true"
                v-on:click="destroy(data.value)"
              ></i>
            </template>
          </b-table>
          <div class="no-data" v-if="data.length == 0">
            <span>Sem dados</span>
          </div>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Swal from "sweetalert2";
import validator from "@/imports/validator/validate";
import text_edition_magazine_validate from "@/imports/validator/models/text_edition_magazine";
import { bus } from "@/main";

export default {
  name: "text-magazine-editions",
  props: {
    text_id: Number
  },
  data() {
    return {
      createParams: {
        magazines: []
      },
      text_magazine_edition: {},
      perPage: 10,
      currentPage: 1,
      rows: 0,
      data: [],
      fields: [
        { key: "magazine_edition.magazine.name", label: "Revista" },
        { key: "magazine_edition", label: "Edição" },
        { key: "page_number", label: "Página" },
        { key: "id", label: "Opções" }
      ]
    };
  },
  mounted() {
    this.text_magazine_edition.text_id = this.text_id;
    this.getCreateParams();
    this.providerData();
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  methods: {
    providerData() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/text_magazine_editions?${this.urlBuild()}`
        )
        .then(response => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
        });
    },
    urlBuild: function() {
      let url =
        "include=magazine_edition.magazine&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        `&filter[text_id]=${this.text_id}`;

      return url;
    },
    getCreateParams: function() {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/magazine_editions/create`)
        .then(data => {
          this.createParams = data.data;
          bus.$emit("changeLoading", false);
        });
    },
    save: function() {
      let errors = validator.validate(
        this.text_magazine_edition,
        text_edition_magazine_validate.model
      );

      if (errors.length == 0) {
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/add_text_magazine_edition`,
          this.text_magazine_edition
        );

        promise.then(response => {
          if (!response.data.error) {
            Swal.fire({
              title: "Item adicionado com sucesso",
              icon: "success",
              onClose: () => {
                this.providerData();
              }
            });
          } else {
            Swal.fire({
              title: response.data.error,
              icon: "error"
            });
          }
        });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    },
    destroy: function(id) {
      Swal.fire({
        title: "Você tem certeza que deseja excluir esse item?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.value) {
          let promise = axios.delete(
            `${process.env.VUE_APP_API_HOST}/api/text_magazine_editions/${id}`
          );

          promise.then(response => {
            Swal.fire({
              title: "Item excluído com sucesso",
              icon: "success",
              onClose: () => {
                this.providerData();
              }
            });
          });
        }
      });
    },
    getMonthLabel: function(value) {
      if (value == "1") return "Janeiro";
      if (value == "2") return "Fevereiro";
      if (value == "3") return "Março";
      if (value == "4") return "Abril";
      if (value == "5") return "Maio";
      if (value == "6") return "Junho";
      if (value == "7") return "Julho";
      if (value == "8") return "Agosto";
      if (value == "9") return "Setembro";
      if (value == "10") return "Outubro";
      if (value == "11") return "Novembro";
      if (value == "12") return "Dezembro";
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.text-magazine-editions {
  .deleteIcon {
    color: $red_primary;
    font-size: 22px;
    margin-left: 8px;
  }
  .deleteIcon:hover {
    cursor: pointer;
  }
}
</style>